import { render, staticRenderFns } from "./AdditionalInformation.vue?vue&type=template&id=6d565920"
import script from "./AdditionalInformation.vue?vue&type=script&lang=ts"
export * from "./AdditionalInformation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports